import React, { useEffect, useState } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useFavoritesStore } from '@/stores/favoritesStore';
import { useProfileStore } from '@/stores/profileStore';

export default function RequireAuth() {
  const { googleId, loadProfile, ensureTifosiCle } = useProfileStore();
  const syncFavorites = useFavoritesStore((s) => s.syncWithServer);
  const location = useLocation();
  const [hydrated, setHydrated] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        await loadProfile();
        const cle = (useProfileStore.getState().tifosiCle || '').trim() || await ensureTifosiCle();
        if (cle && !cancelled) await syncFavorites(cle);
      } finally {
        if (!cancelled) setHydrated(true);
      }
    })();
    return () => { cancelled = true; };
  }, [loadProfile, ensureTifosiCle, syncFavorites]);

  if (!hydrated) return null;

  if (!googleId) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <Outlet />;
}
